export const returnToTemplateSelector = backButton => {
    const fields = backButton.closest('.form-modal').querySelector('.send-email-fields');

    fields.innerHTML = '';
};
